import { gql } from '@apollo/client/core';
import { useQuery } from '@apollo/client/react/hooks/useQuery';

type ActiveRoom = {
	activeRoom: {
		id: string;
		name: string;
	};
};

const QUERY = gql`
	query activeRoom {
		activeRoom @client {
			id: rid
			name
		}
	}
`;

export default (): IdName => {
	const { data } = useQuery<ActiveRoom>(QUERY);

	if (!data) return { id: '', name: '' };

	return data.activeRoom;
};
